<div class="card mt-2">
  <div class="card-body">
    <h4 class="mb-2">Prescriber</h4>
    @if (!selectedProvider) {
      @if (refreshing) {
        <div><mat-spinner diameter="30" /></div>
      } @else {
        @if (!refreshing && prescribers.length > 0) {
          <div class="mt-2">
            <h5>Choose Prescriber</h5>
            <div class="choose-prescribers">
              <app-prescriber-list
                [prescribers]="prescribers"
                (prescriberSelect)="onPrescriberSelect($event)"
                />
            </div>
          </div>
        } @else {
          @if (!selectedPatient) {
            <p class="mt-2 p-2 bg-light">Please select a patient.</p>
          }
          @if (selectedPatient) {
            <p class="mt-2 p-2 bg-light">No prescribers found.</p>
          }
        }
      }
    } @else {
      <div class="d-flex prescriber-selection mt-2">
        <app-prescriber-name [provider]="selectedProvider" [linkToProvider]="true" />
        <div class="text-danger ms-3 prescriber-clear" (click)="onPrescriberClear()">
          <fa-icon [icon]="['fas', 'times']" />
        </div>
      </div>
    }
  </div>
</div>
